import React from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import Topbar from "./Topbar";
import HMenu from "./HMenu/HMenu";
import AnimateLoading from "../../../app/partials/layout/AnimateLoading";
import KTHeader from "../../_assets/js/header";
import * as builder from "../../ducks/builder";
import { LayoutContextConsumer } from "../LayoutContext";
import { getUserByToken
} from "../../../app/crud/auth.crud";

//import { getUserByToken } from "../../../app/crud/auth.crud";


class Header extends React.Component {

    constructor(props) {
    super(props);
   }
   state={
    user:{}
   }

  headerCommonRef = React.createRef();


  componentDidMount() {

/*    getUserByToken().then(response => response.data)
    .then((data) => {
      this.setState({users: data});
      this.state.users.map((user) => (
          this.setState({ user: user })
        ));
 
      
     })
     */
    

    let options = {};
    if (
      this.headerCommonRef.current.getAttribute("data-ktheader-minimize") ===
      "1"
    ) {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    // eslint-disable-next-line no-undef
    new KTHeader(this.headerCommonRef.current, options);
  }

  render() {
    const {
      menuHeaderDisplay,
      headerAttributes,
      headerClasses
    } = this.props;
    return (
      <div
        className={`kt-header kt-grid__item ${headerClasses}`}
        id="kt_header"
        ref={this.headerCommonRef}
        {...headerAttributes}
      >
        <AnimateLoading />
        {/* <!-- begin: Header Menu --> */}
        {/*menuHeaderDisplay && <HMenu />*/}
        {<img alt="logo" src="media/logos/logo-mini-md.png" style={{width:'240px',height:'60px'}} />}
        {/* <div ><h3 className="kt-subheader__title" style={{paddingTop:15, paddingLeft:1}}>
         <LayoutContextConsumer>
              

              {({ subheader: { title } }) => (
                <>
                  {this.state.user.role!=null &&
                  <h3 className="kt-subheader__title">{this.state.user.role +  (title!=null && title!="" ? ' - ' + title : '')}</h3>
                  }
                  
                </>
              )}
            </LayoutContextConsumer>
        
        </h3></div>*/}
        {/* <!-- end: Header Menu --> */}
        {/* <!-- begin:: Header Topbar --> */}
        {/* <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden --> */}
        {/*!menuHeaderDisplay && <div />*/}
        <Topbar />
        {/* <!-- end:: Header Topbar --> */}
      </div>
    );
  }
}

const mapStateToProps = store => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  fluid:
    objectPath.get(store.builder.layoutConfig, "header.self.width") === "fluid"
});

export default connect(mapStateToProps)(Header);
